import { MeetingType as ApiMeetingType } from "../api/meeting_types";

export interface MeetingType {
  id: string;
  title?: string;
  shortDescription?: string;
  description?: string;
  calendarEventTitle?: string;
  notificationTitle?: string;
  notificationDescription?: string;
}

/**
 * How a meeting type is named in the admin panel: its title, or its id when
 * the title is blank (a type can be left untitled in Airtable on purpose).
 */
export const meetingTypeLabel = (meetingType: MeetingType): string =>
  meetingType.title?.trim() || meetingType.id;

export const fromApiMeetingType = (
  apiMeetingType: ApiMeetingType
): MeetingType => {
  return {
    id: apiMeetingType.id,
    title: apiMeetingType.title,
    shortDescription: apiMeetingType.shortDescription,
    description: apiMeetingType.description,
    calendarEventTitle: apiMeetingType.calendarEventTitle,
    notificationTitle: apiMeetingType.notificationTitle,
    notificationDescription: apiMeetingType.notificationDescription,
  };
};
